import { LoaderCircle } from 'lucide-react';

/**
 * Subtle overlay for table refetch operations (pagination, filter changes).
 * Shows user their action is being processed without hiding existing data.
 */
export function SystemLogsTableRefetchOverlay() {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/70 backdrop-blur-[2px]">
      <div className="flex flex-col items-center gap-3 rounded-lg bg-white px-6 py-4 shadow-lg ring-1 ring-gray-200">
        <LoaderCircle className="size-6 animate-spin text-primary-500" />
        <span className="text-sm font-medium text-gray-700">
          Updating results...
        </span>
      </div>
    </div>
  );
}
